import { Link } from "react-router-dom";
import { animeList, genreOptions } from "@/mocks/anime";
import { getGenreIcon } from "@/utils/genreIcons";

export default function CategoryQuick() {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
      {genreOptions.map((genre, index) => {
        const count = animeList.filter((item) => item.genres.includes(genre)).length;
        const isAccent = index % 5 === 2;
        return (
          <Link
            key={genre}
            to={`/category?genre=${encodeURIComponent(genre)}`}
            className="group flex items-center gap-3 rounded-lg border border-background-200/70 bg-background-50 p-3 transition-colors hover:border-primary-200 hover:bg-primary-50 md:p-4"
          >
            <span
              className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-lg text-xl transition-colors ${
                isAccent
                  ? "bg-accent-100 text-accent-700 group-hover:bg-accent-500 group-hover:text-background-50"
                  : "bg-primary-100 text-primary-700 group-hover:bg-primary-500 group-hover:text-background-50"
              }`}
            >
              <i className={getGenreIcon(genre)} />
            </span>
            <span className="min-w-0">
              <span className="block truncate font-heading text-sm font-bold text-foreground-950">
                {genre}
              </span>
              <span className="block text-xs text-foreground-500">{count} 部作品</span>
            </span>
          </Link>
        );
      })}
    </div>
  );
}